<template>
<div>
   <v-alert v-if="success"
      border="bottom"
      color="success"
      dark
    >
      {{ successMensaje }}
    </v-alert>
    <v-alert v-if="error"
      border="bottom"
      color="red"
      dark
    >
    <b>Ocurrió un error al guardar el sector. </b> {{ errorMensaje }}
    </v-alert>
    <v-form v-model='valid' ref="form">
    <v-row>
       <v-col cols='12' md='4'>
        <v-text-field
          v-model='nombre'
          :rules='nameRules'
          filled
          label='Nombre'
          required
        ></v-text-field>
      </v-col>
      <v-col md="2">
        <v-btn v-if='!editar' color="primary" x-large :loading="loading" @click="guardar">
          Guardar
        </v-btn>
        <v-btn v-if='editar' color="warning" x-large :loading="loading" @click="modificar">
          Editar
        </v-btn>
      </v-col>
      <v-col md="2">
            <v-btn color="success" x-large
            @click="listado">Ver Listado</v-btn>
      </v-col>
    </v-row>
  </v-form>
  </div>
</template>
<script>
import { API_URL } from '@/common/config';

const axios = require('axios');

export default {
  data: () => ({
    loadingImage: false,
    successMensaje: '',
    errorMensaje: '',
    success: false,
    error: false,
    loading: false,
    valid: false,
    nombre: '',
    descripcion: '',
    imagen: '',
    sectorProductivo: '',
    nameRules: [(v) => !!v || 'El campo es obligatorio'],
  }),
  props: [
    'editar',
  ],
  methods: {
    resetForm() {
      this.$refs.form.reset();
    },
    async guardar() {
      this.loading = true;
      const data = {
        nombre: this.nombre,
      };
      const url = `${API_URL}api/${this.$route.params.model}/`;
      const header = {
        headers: {
          token: localStorage.getItem('token'),
        },
      };
      await axios.post(url, data, header).then((response) => {
        if (response.data.status === 'success') {
          this.success = true;
          this.successMensaje = response.data.message;
          this.resetForm();
        } else if (response.data.status === 'error') {
          this.error = true;
          this.errorMensaje = response.data.message;
        }
        this.loading = false;
      });
    },
    async modificar() {
      this.loading = true;
      axios
        .post(`${API_URL}api/sectoresProductivos/editar/`, {
          token: localStorage.getItem('token'),
          nombre: this.nombre,
          sectorProductivo_id: this.$route.params.id,
        })
        .then((response) => {
          if (response.data.status === 'success') {
            this.$router.push(`/listado/${this.$route.params.model}/`);
          } else {
            this.error = true;
            this.errorMensaje = response.data.message;
          }
          this.loading = false;
        });
    },
    listado() {
      this.$router.push(`/listado/${this.$route.params.model}/`);
    },
    presentarDatos() {
      axios
        .get(
          `${API_URL}api/sectoresProductivos/${this.$route.params.id}`, // ver
          {
            headers: {
              token: localStorage.getItem('token'),
            },
          },
        )
        .then((response) => {
          this.nombre = response.data.sectorProductivo.nombre;
        });
    },
  },
  created() {
    if (this.editar) {
      this.presentarDatos();
    }
  },
};
</script>
